import { createElement } from 'react';

import { Roles } from '../constants';
import IntakeQuestionnaire from '../pages/questionnaires/intake';
import { INTAKE_QUESTIONNAIRE_ROUTE_PATH } from '../pages/questionnaires/intake/constants';
import OnboardingQuestionnaire from '../pages/questionnaires/onboarding';
import { ONBOARDING_QUESTIONNAIRE_ROUTE_PATH } from '../pages/questionnaires/onboarding/constants';

export const questionnaireRoutes = [
  {
    path: ONBOARDING_QUESTIONNAIRE_ROUTE_PATH,
    type: 'private',
    elem: createElement(OnboardingQuestionnaire),
    roles: [
      Roles.Admin,
      Roles.Bcba,
      Roles.OnboardingCoordinator,
      Roles.ClientSuccessManager,
      Roles.Guardian,
    ],
  },
  {
    path: INTAKE_QUESTIONNAIRE_ROUTE_PATH,
    type: 'private',
    elem: createElement(IntakeQuestionnaire),
    // TODO(FA-3280): roles carried over from onboarding as a placeholder — confirm intake access roles with the team.
    roles: [
      Roles.Admin,
      Roles.Bcba,
      Roles.OnboardingCoordinator,
      Roles.ClientSuccessManager,
      Roles.Guardian,
    ],
  },
];
